import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function DistributorsPage() {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  const distributors = [
    'ABB',
    'ADI',
    'Allis Chalmers (ITT Allis Chambers)',
    'Aries',
    'Armstrong',
    'Armstrong Pumps',
    'ARO',
    'ASCO',
    'ASHCROFT',
    'Aurora Pumps',
    'Barber Coleman',
    'Belimo',
    'Bell & Gossett',
    'Bellofram',
    'Broan',
    'Burkert Valves',
    'Burks Pumps',
    'B/W Controls',
    'Carrier',
    'Chromalox',
    'Crown Pumps',
    'CR Laurence',
    'Darling Fire Pumps',
    'Dayton',
    'Dwyer',
    'Erie',
    'Fireye',
    'Fisher',
    'Furnas',
    'General Filter',
    'Gerand',
    'Gould',
    'Griswold',
    'Gusher Pumps',
    'Honeywell Air Purification',
    'Honeywell Building Controls',
    'Honeywell Flame Safeguard',
    'Honeywell Industrial Controls',
    'ITT Allis Chambers',
    'Jacuzzi',
    'Johnson Controls',
    'KEG Technology',
    'Lamp Shades',
    'LMI',
    'Maid O Mist',
    'Magnatrol',
    'Maxitrol',
    'Maxon',
    'McDaniel',
    'McDonnell & Miller',
    'McQuay International',
    'Mercoid',
    'Metraflex',
    'Microswitch',
    'Myers Pumps',
    'New York Blower',
    'Paco Pumps',
    'Parker',
    'Penn / Johnson',
    'Pennbarry',
    'Proco',
    'Regal Chlorinators',
    'Robertshaw',
    'SIEMENS',
    'SnapTite',
    'Spirax Sarco',
    'Super Radiator Coils',
    'Superior Technology Soft Start',
    'Taco Pump',
    'Teel',
    'Teleadapt',
    'Topog-E',
    'Trane',
    'Trerice',
    'United Electric',
    'U.S. Gauge',
    'Watlow',
    'Watts',
    'Weinman',
    'Weiss',
    'Weksler',
    'Wellman',
    'White Rodgers',
    'WIKA',
    'York'
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Page Header */}
      <section className="relative py-20 md:py-28 lg:py-32 overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/cef5c2a5a8006757a47790d177324f3e.jpg"
            alt="Hotel Maintenance Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0D1B3E]/95 via-[#0D1B3E]/85 to-[#0066FF]/70"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 relative z-10">
          <div className="text-center">
            <nav className="mb-6 md:mb-8">
              <Link 
                to="/" 
                className="text-white/80 hover:text-white text-sm transition-colors duration-300"
              >
                Home
              </Link>
              <span className="text-white/60 mx-3">/</span>
              <span className="text-white text-sm">Trusted Partners</span>
            </nav>
            
            <span className="text-white text-xs md:text-sm font-semibold tracking-[0.15em] uppercase">
              COMPLETE NETWORK
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-4 md:mt-6 mb-6 md:mb-8">
              Trusted Partners
            </h1>
            <p className="text-base md:text-lg lg:text-xl text-white/90 leading-relaxed max-w-3xl mx-auto px-4">
              Our comprehensive network of trusted distributor partners ensures reliable access to high-quality equipment and components for all your facility management needs.
            </p>
          </div>
        </div>
      </section>

      {/* Distributors List */}
      <section className="bg-white py-16 md:py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16 lg:mb-20">
            <span className="text-[#0D1B3E] text-xs md:text-sm font-semibold tracking-[0.15em] uppercase">
              TRUSTED PARTNERSHIPS
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#0D1B3E] mt-4 md:mt-6 mb-6 md:mb-8">
              {distributors.length} Industry Partners
            </h2>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto px-4">
              From industry giants to specialized manufacturers, our extensive distributor network covers every aspect of facility management, HVAC, pumping, automation, and industrial controls.
            </p>
          </div>

          {/* Distributors Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
            {distributors.map((distributor, index) => (
              <div
                key={index}
                className="bg-[#F8F9FA] rounded-xl p-5 md:p-6 border border-gray-200 hover:border-[#0066FF] hover:shadow-md transition-all duration-300 group cursor-pointer"
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#0D1B3E] to-[#0066FF] flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-line text-sm text-white"></i>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-[#0D1B3E] group-hover:text-[#0066FF] transition-colors duration-300">
                    {distributor}
                  </h3>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="text-center mt-12 md:mt-16 lg:mt-20">
            <div className="bg-[#F8F9FA] rounded-2xl p-8 md:p-10 lg:p-12 border border-gray-200">
              <h3 className="text-xl md:text-2xl font-bold text-[#0D1B3E] mb-3 md:mb-4">
                Need Equipment from Any of These Partners?
              </h3>
              <p className="text-base md:text-lg text-gray-600 mb-6 md:mb-8 max-w-2xl mx-auto px-4">
                Our team can source components, repair kits, and equipment from any of our trusted distributors. Don't see the distributor you're looking for? No problem—we have access to an even wider network and can still source the products you need. Contact us for a customized quote.
              </p>
              <a
                href="/quote"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation('/quote');
                }}
                className="inline-flex items-center bg-[#0066FF] text-white px-6 md:px-8 py-3 md:py-4 rounded-xl font-semibold hover:bg-[#0052CC] transition-all duration-300 whitespace-nowrap text-sm md:text-base cursor-pointer"
              >
                Request Quote
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
